import { render, staticRenderFns } from "./External.vue?vue&type=template&id=218747b1&"
import script from "./External.vue?vue&type=script&lang=js&"
export * from "./External.vue?vue&type=script&lang=js&"
import style0 from "./External.vue?vue&type=style&index=0&id=218747b1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports